// @ts-ignore
import OnIdle from '@mindtickle/ui-shell-core/IdleUntilUrgent';
import { useHeaderOffset } from '~/components/Header';

import { StyledLayout } from './styles';

import Header from '~/components/Header';

function Layout({ children }: { children: JSX.Element }) {
  const offset = useHeaderOffset();

  return (
    <StyledLayout $offset={offset}>
      <OnIdle>
        <Header />
      </OnIdle>
      <div className="shell-layout-admin-content">{children}</div>
    </StyledLayout>
  );
}

export default Layout;
